import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { ThirdPartyContractModel } from "@models/thirdparty/ThirdPartyContractModel";
import { Observable } from "rxjs";
import { DocumentMethods } from "@methods/DocumentMethods";
import { HistoryModel, HistoryChange } from "@models/history/HistoryModel";
import { ThirdPartyPermissions } from "@models/thirdparty/ThirdPartyPermissions";
import { isGuid } from "@methods/uniqueMethods";
import { CustomFieldStandingDataModel } from "@models/customfields/CustomFieldStandingDataModel";
import { IMetadata } from "@models/IMetadata";
import { addParameterToUrl } from "@methods/CommonMethods";

@Injectable()
export class ThirdPartyContractDataService extends ApiDataService {
    constructor() {
        super("thirdpartycontract");
    }

    public getContractData(guid: string) {
        const url = `/contractdata/${guid}`;
        return this.get<ThirdPartyContractModel>(url);
    }

    public getContracts(thirdPartyGuid: string): Observable<any[]> {
        const url = `/contracts/${thirdPartyGuid}`;
        return this.get<any[]>(url);
    }

    public getContractsMetadata(
        thirdPartyGuid: string,
        idsToInclude: string[],
    ): Observable<IMetadata[]> {
        let url = `/contracts/${thirdPartyGuid}/metadata`;
        url = addParameterToUrl(url, "idsToInclude", idsToInclude);
        return this.get<IMetadata[]>(url);
    }

    public deleteContract(guid: string): Observable<string[]> {
        const url = `/${guid}/deletecontract`;
        return this.delete(url);
    }

    public getPermissions(guid: string): Observable<ThirdPartyPermissions> {
        const url = isGuid(guid) ? `/${guid}/permissions` : "/null/permissions";
        return this.get<ThirdPartyPermissions>(url);
    }

    public storeContract(model: ThirdPartyContractModel) {
        const url = `/storeContract`;
        const formData = DocumentMethods.convertToFormDataWithFiles("contract", model);
        return this.post<string>(formData, url);
    }

    public getCustomFields(): Observable<CustomFieldStandingDataModel[]> {
        const url = `/customfields`;
        return this.get<CustomFieldStandingDataModel[]>(url);
    }

    public getHistory(guid: string): Observable<HistoryModel[]> {
        const url = `/${guid}/history`;
        return this.get<HistoryModel[]>(url);
    }

    public getHistoryChanges(guid: string, mutationId: number): Observable<HistoryChange[]> {
        const url = `/${guid}/history/${mutationId}`;
        return this.get<HistoryChange[]>(url);
    }
}
